// Add your custom JS here.

jQuery(function ($) {
    $('.show-more-btn').click(function () {
        var textContainer = $(this).parent().find('.trust-text');
        textContainer.toggleClass('collapsed');
        if (textContainer.hasClass('collapsed')) {
            $(this).html('<div class="arrow"></div>Show More');
        } else {
            $(this).html('<div class="arrow up"></div>Show Less');
        }
    });
    $('.insurance-title').click(function () {
        var descriptionContainer = $(this).parent().find('.insurance-description');
        descriptionContainer.toggleClass('open');
        if (descriptionContainer.hasClass('open')) {
            $(this).find('.plus').hide();
            $(this).find('.minus').show();
        } else {
            $(this).find('.plus').show();
            $(this).find('.minus').hide();
        }
    });
});